import type { TokenStore } from '@pedigreesmart/api-client'

const REFRESH_KEY = 'pedigreesmart.refresh'

/**
 * Access token in memory, refresh token in localStorage.
 *
 * Keeping the access token out of storage limits what an XSS payload can
 * exfiltrate to a 15-minute window. The refresh token has to survive a reload,
 * so it is stored; the production deployment should move it to an httpOnly
 * cookie, at which point only this file changes.
 */
export function createTokenStore(): TokenStore {
  let accessToken: string | null = null

  return {
    getAccessToken: () => accessToken,

    getRefreshToken: () => {
      try {
        return localStorage.getItem(REFRESH_KEY)
      } catch {
        return null
      }
    },

    setTokens(newAccessToken: string, refreshToken: string) {
      accessToken = newAccessToken
      try {
        localStorage.setItem(REFRESH_KEY, refreshToken)
      } catch {
        // Private browsing or storage disabled: the session simply lasts
        // until the tab is closed.
      }
    },

    clear() {
      accessToken = null
      try {
        localStorage.removeItem(REFRESH_KEY)
      } catch {
        // Nothing to do.
      }
    },
  }
}
